
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/phone_multicomplete/templates/suggestions"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='js-suggestionsChildWrapper'></div>\n";
},"useData":true});
    }).call(this);
  